import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BaseClassService } from "./Interceptors/base-class.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { StorageModule } from "@ngx-pwa/local-storage";
import { LoginComponent } from "./login/login.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { SharedComponentModule } from "./SharedComponents/SharedComponent.module";
import { MobileOtpComponent } from "./mobile-otp/mobile-otp.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { StarRatingModule } from "angular-star-rating";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { IonicModule } from "@ionic/angular";
import { RatingModule } from "ng-starrating";

import { BackButtonDisableModule } from "angular-disable-browser-back-button";

import { Error503Component } from "./error503/error503.component";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { WebcamModule } from "ngx-webcam";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { LinkAccountOpeningFormComponent } from "./link-account-opening-form/link-account-opening-form.component";
import { ConversionApplicationFormComponent } from "./conversion-application-form/conversion-application-form.component";
import { AmountInwordsPipe } from "./amount-inwords.pipe";
import { CurrencyPipe, DecimalPipe } from "@angular/common";
import { CRSdeclarationComponent } from "./crsdeclaration/crsdeclaration.component";
import { CDCTransferAmountRequestComponent } from "./cdctransfer-amount-request/cdctransfer-amount-request.component";
import { MobileSecOTPComponent } from "./mobile-sec-otp/mobile-sec-otp.component";
import { FormatmoneypipePipe } from "./formatmoneypipe.pipe";
import { DatePipe } from "@angular/common";
import { BotDetectCaptchaModule } from "angular-captcha";
import * as APIURL from "../assets/APIURL.json";
import { ReCaptchaModule } from "angular-recaptcha3";
import { MobileVerificationComponent } from "./mobile-verification/mobile-verification.component";
import { PAKnationalitydetailsComponent } from "./PAK-nationality-details/PAK-nationality-details.component";
import { DeviceDetectorService } from "ngx-device-detector";

import { AgmCoreModule } from "@agm/core";
//import { InformationGatheringComponent } from './register/information-gathering/information-gathering.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
  declarations: [
    AppComponent,
    MobileVerificationComponent,
    LoginComponent,
    MobileOtpComponent,
    Error503Component,
    ChangePasswordComponent,
    LinkAccountOpeningFormComponent,
    ConversionApplicationFormComponent,
    AmountInwordsPipe,
    FormatmoneypipePipe,
    CRSdeclarationComponent,
    CDCTransferAmountRequestComponent,
    MobileSecOTPComponent,
    FormatmoneypipePipe,
    PAKnationalitydetailsComponent,
    //InformationGatheringComponent,
  ],
  imports: [
    IonicModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAqwqJ03y0-oICRNSsnWBLjADSPy596fLg",
      libraries: ["places"],
    }),

    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: APIURL.sitekey,
      },
      normal: {
        sitekey: APIURL.sitekey,
      },
      language: "en",
    }),
    BotDetectCaptchaModule.forRoot({
      captchaEndpoint: APIURL.URL + "simple-captcha-endpoint.ashx",
    }),
    BrowserModule,
    StarRatingModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    WebcamModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxMaskModule.forRoot(),
    StorageModule.forRoot({ IDBNoWrap: true }),
    SharedComponentModule,
    HttpClientModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    RatingModule,
    Ng2SearchPipeModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BaseClassService,
      multi: true,
    },
    
    {
      provide: DeviceDetectorService,
    },
    
    CurrencyPipe,
    DecimalPipe,
    AmountInwordsPipe,
    FormatmoneypipePipe,
    DatePipe,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
